import { Container } from './style';



function Rectangle() {
  return (
    <>
        <Container />
        
    </>
  );
}

export default Rectangle;
